"use client";

import { GithubCommit } from "@/constants/schema/github-commit-schema";
import { format } from "date-fns";
import React, { useMemo, useState } from "react";
import { ActivityCalendar } from "react-activity-calendar";

const GithubCommitGraph = ({ data }: { data: GithubCommit }) => {
  const [contributionMessage, setContributionMessage] = useState<string | null>("");

  // Compute past 365 dates only once
  const dates = useMemo(
    () =>
      Array.from({ length: 365 }, (_, i) =>
        format(new Date(Date.now() - i * 24 * 60 * 60 * 1000), "yyyy-MM-dd"),
      ),
    [],
  );

  // Map dates to commits using useMemo for performance
  const commits = useMemo(() => {
    return dates
      .map((date) => data.contributions.find((commit) => commit.date === date))
      .filter((commit) => commit !== undefined);
  }, [dates, data.contributions]);

  // Compute total count of commits as a memoized value
  const totalCountCommits = useMemo(() => {
    return Object.values(data.total).reduce((acc, value) => acc + value, 0);
  }, [data.total]);

  return (
    <div className="box">
      <ActivityCalendar
        colorScheme="dark"
        hideColorLegend
        data={commits}
        weekStart={0}
        blockMargin={2.5}
        blockRadius={2.5}
        blockSize={10.1}
        hideTotalCount
        eventHandlers={{
          onMouseEnter: () => (activity) => {
            setContributionMessage(
              `${activity.count} contributions in ${format(new Date(activity.date), "dd MMM yyyy")}`,
            );
          },
          onMouseLeave: () => () => {
            setContributionMessage(null);
          },
        }}
      />
      <p className="jetbrains-mono mt-2 text-xxs text-muted-foreground">
        {contributionMessage
          ? contributionMessage
          : `Total ${totalCountCommits} contributions in lifetime`}
      </p>
    </div>
  );
};

export default GithubCommitGraph;
